import { filterDynamicFieldsMap } from '../shared/components/common/DynamicFields';
import { userWorkflowUpdateAction } from '../shared/actions/userActions';

import { caseSetServerError } from '../shared/actions/caseActions';
import { userClientUpdateAction } from './../shared/actions/userActions';


export const convertDynamicFieldsToData = (currentProps,
                                           fieldsMapName,
                                           dynamicFieldsName,
                                           newData) => {

    let fieldsMap = currentProps[fieldsMapName];
    let data = {...newData};
    delete data[dynamicFieldsName];
    let fieldsMapFiltered = filterDynamicFieldsMap(fieldsMap, false);
    for (let i = 0; i < fieldsMapFiltered.length; i++) {
        let name = fieldsMapFiltered[i].name;
        let value = newData[dynamicFieldsName][i];
        if (value) {
            data[name] = value;
        } else {
            data[name] = "";
        }
    }

    return data;
};

export const onWorkflowFormEditorSave = (dispatch, workflow, success = undefined) => {
    dispatch(userWorkflowUpdateAction(workflow))
        .then(result => {
            if (!result.data) {
                dispatch(caseSetServerError('Failed to save modified workflow.'));
                return;
            }

            if (success) {
                success();
            }

        }).catch(error => {
            dispatch(caseSetServerError(error));
        });
};


export const onClientFormEditorSave = (dispatch, client, success = undefined) => {
    dispatch(userClientUpdateAction(client))
        .then(result => {
            if (!result.data) {
                dispatch(caseSetServerError('Failed to save modified client.'));
                return;
            }

            if (success) {
                success();
            }

        }).catch(error => {
            dispatch(caseSetServerError(error));
        });
};